import { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import Flex from "../../../../components/flex"
import { analysisStore } from "@/routes/apt/[apt_code]/analysis/analysis-store"
import { langStore } from "@/stores/lang-store"
import HeaderWrapperMobile from "../header-wrapper-mobile"
import ImageBox from "@/components/image-box"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import DropdownDong from "../_parts/dropdown-dong"
import { headerBundle } from "./analysis-header-const"

const AnalysisHeaderMobile = ({ position = "sticky" }) => {
  const navigate = useNavigate()
  const { lang } = langStore()
  const pickApt = aptSearchStore((s) => s.pickApt)

  const { dongs, originDongs, selectedDong, setSelectedDong, dongBadgesMap } = analysisStore()

  // --- 추가된 로직: 임시 선택 상태 ---
  const [tempDong, setTempDong] = useState(selectedDong)

  const [open, setOpen] = useState(false)
  const rootRef = useRef(null)

  useEffect(() => {
    analysisStore.getState().dongMapping(originDongs)
  }, [lang, originDongs])

  useEffect(() => {
    if (!open) return
    const onDown = (e) => {
      if (rootRef.current && rootRef.current.contains(e.target)) return
      setOpen(false)
    }
    document.addEventListener("mousedown", onDown)
    document.addEventListener("touchstart", onDown)
    return () => {
      document.removeEventListener("mousedown", onDown)
      document.removeEventListener("touchstart", onDown)
    }
  }, [open])

  // 1. 드롭다운 변경 시: 스토어가 아닌 '임시 상태'만 변경
  const handleTempChange = (id) => {
    setTempDong(id)
  }

  // 2. 검색 버튼 클릭 시: '임시 상태'를 '진짜 스토어'에 반영
  const handleConfirmSearch = () => {
    setSelectedDong(tempDong)
    setOpen(false)
  }

  return (
    <HeaderWrapperMobile position={position}>
      <Flex className="items-center w-full justify-between" gap={2}>
        <div
          className="flex items-center gap-3 cursor-pointer hover:opacity-70 transition-opacity"
          onClick={() => navigate("/select/apt")}
        >
          <ImageBox
            src="/images/toicos-logo-a.png"
            className="w-8 h-8 object-contain"
            alt="Toicos Logo"
          />
          <h1 className="font-bold text-lg text-slate-800 truncate max-w-[50vw]">
            {pickApt.apt_name}
          </h1>
        </div>

        <Flex className="items-center relative mr-3" gap={3}>
          <div ref={rootRef} className="relative">
            <button
              onClick={() => setOpen((v) => !v)}
              className={`h-10 w-10 rounded-md flex items-center justify-center cursor-pointer transition-colors
                ${open ? "bg-blue-100 text-blue-600" : "bg-transparent text-gray-700"}`}
            >
              <svg
                viewBox="0 0 24 24"
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle cx="11" cy="11" r="7" />
                <path d="M20 20l-3.5-3.5" />
              </svg>
            </button>

            {open && (
              <div className="fixed left-0 right-0 z-50 px-4" onClick={(e) => e.stopPropagation()}>
                <div className="bg-white rounded-xl border border-gray-200 shadow-2xl p-5 w-full">
                  <div className="flex flex-col gap-5">
                    <div className="w-full">
                      <p className="text-xs font-semibold text-gray-400 mb-2 ml-1">
                        {headerBundle.selectDong[lang] || "동 선택"}
                      </p>
                      <DropdownDong
                        options={dongs}
                        optionClassName="w-full"
                        onChange={(id) => handleTempChange(id)} // 임시 저장함수 호출
                        value={tempDong} // 임시 값 사용
                        unitStatusMap={dongBadgesMap}
                      />
                    </div>

                    <button
                      onClick={handleConfirmSearch} // 버튼 클릭 시에만 페이지 변경 발생
                      className="w-full py-2.5 rounded-lg bg-blue-600 text-white font-bold text-sm hover:bg-blue-700 transition-colors shadow-md"
                    >
                      {headerBundle.search[lang]}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </Flex>
      </Flex>
    </HeaderWrapperMobile>
  )
}

export default AnalysisHeaderMobile
